// extracted by mini-css-extract-plugin
export default {"wwdTilesSection":"WhatWeDo_wwdTilesSection__UpnRD","wwdTilesDivider":"WhatWeDo_wwdTilesDivider__+7SeI","wwdContentBanner":"WhatWeDo_wwdContentBanner__RxcV9"};